import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
export var Requestor = /*#__PURE__*/function () {
  function Requestor(requestor) {
    _classCallCheck(this, Requestor);

    this.requestor = void 0;
    this.requestor = requestor;
  }

  _createClass(Requestor, [{
    key: "get",
    value: function get(templateUrl, config) {
      return this.requestor.get(templateUrl, config);
    }
  }, {
    key: "delete",
    value: function _delete(templateUrl, config) {
      return this.requestor["delete"](templateUrl, config);
    }
  }, {
    key: "head",
    value: function head(templateUrl, config) {
      return this.requestor.head(templateUrl, config);
    }
  }, {
    key: "post",
    value: function post(templateUrl, data, config) {
      return this.requestor.post(templateUrl, data, config);
    }
  }, {
    key: "put",
    value: function put(templateUrl, data, config) {
      return this.requestor.put(templateUrl, data, config);
    }
  }, {
    key: "patch",
    value: function patch(templateUrl, data, config) {
      return this.requestor.patch(templateUrl, data, config);
    }
  }]);

  return Requestor;
}();